// The Dowgate review method: the routes and the sidebar rows of `dowgate.onboarding.method` (SEP-288, ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const SuitabilityRefreshPanel = lazy(() =>
    import('./onboarding-method.slots').then((m) => ({ default: m.SuitabilityRefreshPanel })),
);

const FinalApprovalsCard = lazy(() =>
    import('./onboarding-method.slots').then((m) => ({ default: m.FinalApprovalsCard })),
);

export default defineWebFeature({
    id: 'dowgate.onboarding.method',
    routes: [
        {
            frontend: 'comply',
            path: 'suitability-refreshes',
            lazy: () => import('@/pages/comply/suitability-refreshes/page'),
        },
        {
            frontend: 'comply',
            path: 'final-approvals',
            lazy: () => import('@/pages/comply/final-approvals/page'),
        },
    ],
    nav: [
        // --- Consumer Duty ---
        // SEP-288 - the refresh outcomes and the new mandates that wait for a
        // Compliance decision.
        {
            frontend: 'comply',
            key: 'suitability-refreshes',
            label: 'Refresh Outcomes',
            href: '/comply/suitability-refreshes',
            icon: 'ClipboardCheck',
            group: 'consumer-duty',
            order: 235,
        },
        // SEP-334 - the cases that the IM sent for the final approval, and the
        // cases that Compliance decided.
        {
            frontend: 'comply',
            key: 'final-approvals',
            label: 'Final Approvals',
            href: '/comply/final-approvals',
            icon: 'ClipboardCheck',
            group: 'consumer-duty',
            order: 236,
        },
    ],
    slots: {
        // The refresh of the version on screen: the checklist, the outcome,
        // the Compliance decision and the letter or the mandate.
        'fact-find.version.panels': [
            { key: 'suitability-refresh', order: 10, Component: SuitabilityRefreshPanel },
        ],
        // SEP-334. The cases that wait for the final approval, on the Comply Dashboard.
        'comply.dashboard.cards': [
            {
                key: 'final-approvals',
                order: 20,
                title: 'Final approvals to give',
                summary: 'The cases that wait for the final approval of Compliance.',
                span: 6,
                rows: 5,
                // The card reads its queue in its own hook, so the page cannot
                // know the count. The card thus never collapses and never
                // raises the hidden cue (SEP-296).
                count: () => null,
                emptyBehaviour: 'keep',
                Component: FinalApprovalsCard,
            },
        ],
    },
});
